module.exports = __webpack_public_path__ + "Roboto-Bold.c7f4667b59b9bc95130e.svg";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-Bold.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.svg
// module chunks = 34